import { AfterSalesRequest } from '../types/afterSales';

type ApiResult<T> = { success: boolean; data?: T; error?: string; canManage?: boolean };

async function request<T>(path: string, options?: RequestInit): Promise<ApiResult<T>> {
  const token = localStorage.getItem('token');
  const response = await fetch(path, {
    ...options,
    headers: {
      ...(options?.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options?.headers || {})
    }
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || '售后请求失败');
  return result;
}

export function listTeamAfterSales(category: '耗材申请' | '试剂申请') {
  return request<AfterSalesRequest[]>(`/api/after-sales?category=${encodeURIComponent(category)}`);
}

export function createAfterSales(payload: Record<string, unknown>) {
  return request<AfterSalesRequest>('/api/after-sales', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function confirmAfterSalesPrice(id: string, approved: boolean, comment = '') {
  return request<AfterSalesRequest>(`/api/after-sales/${id}/team-price-confirm`, {
    method: 'PUT',
    body: JSON.stringify({ approved, comment })
  });
}

export function submitAfterSalesReturn(id: string, trackingNumber: string) {
  return request<AfterSalesRequest>(`/api/after-sales/${id}/return-shipment`, {
    method: 'PUT',
    body: JSON.stringify({ trackingNumber })
  });
}

export function completeAfterSales(id: string) {
  return request<AfterSalesRequest>(`/api/after-sales/${id}/complete`, {
    method: 'PUT',
    body: JSON.stringify({})
  });
}

export function cancelAfterSales(id: string) {
  return request<AfterSalesRequest>(`/api/after-sales/${id}/cancel`, {
    method: 'PUT',
    body: JSON.stringify({})
  });
}
